import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core';
import { RouterReducerState } from '@ngrx/router-store';
import { Store } from '@ngrx/store';
import { Observable } from 'rxjs';
import { map, filter, switchMap } from 'rxjs/operators';
import { AuthService } from 'src/app/modules/auth/services/auth.service';
import { LocationPickerLayout } from '../../models/LocationPickerLayout';
import { ReportCardLayout } from '../../models/ReportCardLayout';
import * as fromAuth from 'src/app/store/auth';
import { logout } from 'src/app/store/auth/auth.actions';
import { selectRouteParams } from 'src/app/store/router/selectors';
import { HeaderState } from 'src/app/store/header/header.reducer';
import {
  isAuditsPageSelector,
  isReportsPageSelector,
  isAdminPageSelector,
  isAuditingPageSelector,
} from 'src/app/store/header/header.selectors';
import { toggleSidebarAdmin } from 'src/app/modules/admin/store/ui/ui.actions';
import { toggleSidebarAuditing } from 'src/app/modules/auditing-components/store/ui/ui.actions';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class HeaderComponent implements OnInit {
  selectedLocation$: Observable<number | 'all'>;
  cardLayoutValue$: Observable<ReportCardLayout>;

  user$ = this.store.select(fromAuth.selectUser);
  locationPickerLayout$: Observable<LocationPickerLayout>;
  hasMultipleLocations$: Observable<boolean>;
  hasMultipleAreas$: Observable<boolean>;

  isAuditsPage$: Observable<boolean>;
  isReportsPage$: Observable<boolean>;
  isAdminPage$ = this.store.select(isAdminPageSelector);
  isAuditingPage$ = this.store.select(isAuditingPageSelector);

  isAdmin$ = this.store.select(fromAuth.selectIsAdmin);

  home$ = this.store.select(fromAuth.selectRoleHomePage);

  constructor(
    public auth: AuthService,
    private store: Store<{
      auth: fromAuth.AuthState;
      router: RouterReducerState;
      header: HeaderState;
    }>,
  ) {}

  ngOnInit() {
    this.locationPickerLayout$ = this.user$.pipe(
      filter(Boolean),
      switchMap(user => {
        return this.store.select(fromAuth.selectUserDataCategory);
      }),
    );

    this.hasMultipleLocations$ = this.locationPickerLayout$.pipe(
      map(layout => layout === LocationPickerLayout.MultiLocation || layout === LocationPickerLayout.MultiCustomer),
    );

    this.hasMultipleAreas$ = this.locationPickerLayout$.pipe(map(layout => layout !== LocationPickerLayout.SingleArea));

    this.selectedLocation$ = this.store.select(selectRouteParams).pipe(map(params => (params.locationId ? +params.locationId : 'all')));

    this.isAuditsPage$ = this.store.select(isAuditsPageSelector);
    this.isReportsPage$ = this.store.select(isReportsPageSelector);
  }

  logout() {
    this.store.dispatch(logout());
  }

  toggleSidebarAdmin() {
    this.store.dispatch(toggleSidebarAdmin());
  }

  toggleSidebarAuditing() {
    this.store.dispatch(toggleSidebarAuditing());
  }
}
